import {
  ADD_POST,
  REMOVE_POST,
  UPDATE_POST,
  SET_POSTS_FOR_BLOG
} from '../actions/postsActions';

const initialState = {
  data: [],
  metadata: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_POST: return onAddPost(state, action);
    case REMOVE_POST: return onRemovePost(state, action);
    case UPDATE_POST: return onUpdatePost(state, action);
    case SET_POSTS_FOR_BLOG: return onSetPostsForBlog(state, action);
    default:
      return state;
  }
}

const onSetPostsForBlog = (state, action) => {
  console.log(action);
  return { 
    data: [...action.posts],
    metadata: action.metadata
  }
}

const onRemovePost = (state, action) => {
  return {
    data: state.data.filter(post => post._id !== action.id),
    metadata: {
      ...state.metadata,
      total: state.metadata.total - 1
    }
  }
}

const onAddPost = (state, action) => {
  let newPosts = state.data.filter(() => true);

  newPosts.push(action.post);

  return {
    data: newPosts,
    metadata: state.metadata
  }
}

const onUpdatePost = (state, action) => {
  
  let newPosts = state.data.filter(() => true);

  for(let i in newPosts) {
    if(newPosts[i]._id === action.post._id) {
      Object.assign(newPosts[i], action.post);
      break;
    }
  }

  return {
    metadata: state.metadata,
    data: newPosts
  };
}

